<template>
  <div @click="showDialog" class="pointer-cursor">
    <v-banner
      single-line
      :bg-color="bannerBackgroundColor"
      class="pr-4 py-0 text-center boost-banner"
    >
      <span class="boost-banner-text">
        {{ boostText }}
      </span>

      <v-icon v-if="isEnabled" class="px-1" color="white" size="18"
        >fa-light fa-rocket-launch</v-icon
      >
      <v-icon v-else class="px-1" color="white" size="18"
        >fa-light fa-rocket</v-icon
      >
    </v-banner>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { useEventBus } from "@/event-bus/bus";
import $const from "@/utils/constants";

export default {
  name: "BrokerBoostBanner",
  props: {
    isEnabled: {
      type: Boolean,
      default: false,
    },
  },
  components: {},
  computed: {
    ...mapGetters("user", ["me", "responsive", "brokerBoostStatus"]),
    ...mapGetters("auth", [
      "sessionAutoRefresh",
      "session",
      "sessionExpiration",
    ]),
    boostText() {
      return this.isEnabled
        ? `Broker Boost is on ${this.brokerBoostStatus.percentage}%`
        : this.boostOffText;
    },
    bannerBackgroundColor() {
      return this.isEnabled
        ? this.brokerBoostEnabledColor
        : this.brokerBoostDisabledColor;
    },
  },
  data() {
    return {
      upHere: true,
      brokerBoostEnabledColor: "#006B59",
      brokerBoostDisabledColor: "#6D6D6D",
      boostOnText: "Broker Boost is ON. Agent scores are being boosted.",
      boostOffText:
        "Broker Boost is OFF. Click to learn more about Broker Boost.",
      boostOffTextTest:
        "Broker Boost is OFF. Turn it ON to improve your agents scores and get more referrals!",
    };
  },

  methods: {
    showDialog() {
      console.log("Send an event!");
      const _eventBus = useEventBus();
      _eventBus.$emit($const.EVENT_BUS.SHOW_BROKER_BOOST_BANNER, true);
    },
  },
  mounted() {},
};
</script>

<style scoped>
.boost-banner {
  justify-content: center;
  align-content: center;
  padding-top: 0;
  padding-bottom: 0;
  height: 40px;
}

.boost-banner-text {
  color: white;
}

.pointer-cursor {
  cursor: pointer;
}
</style>
